import { useWindowTitle } from '@cibo/profile'
import { ExtendedTheme, Markdown, Swatch } from '@cibo/ui'
import { Box, Typography, useTheme } from '@mui/material'
import { Stack } from '@mui/system'
import { AvailablePrograms } from 'components/AvailablePrograms'
import { LayoutSection } from 'components/ImpactLayout'
import { useTranslation } from 'react-i18next'

export const ProgramsRoot = () => {
  const { t } = useTranslation('impact/pages/ProgramsRoot')
  useWindowTitle(t('windowTitle'))
  const {
    palette: { success, warning, info, programEnrollmentClosed, programClosed, future },
  } = useTheme<ExtendedTheme>()

  return (
    <LayoutSection autoHeight container>
      <Markdown color="text.secondary">{t('intro.md')}</Markdown>

      <Box>
        <AvailablePrograms />
      </Box>
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center" spacing={1}>
          {/* @ts-ignore */}
          <Swatch color={success.main} />
          <Typography variant="caption">{t('enrolled')}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          {/* @ts-ignore */}
          <Swatch color={info.light} />
          <Typography variant="caption">{t('opportunity')}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Swatch color={future.main} />
          <Typography variant="caption">{t('futureOpportunity')}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          {/* @ts-ignore */}
          <Swatch color={warning.main} />
          <Typography variant="caption">{t('openEnrollments')}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Swatch color={programEnrollmentClosed.main} />
          <Typography variant="caption">{t('programEnrollmentClosed')}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Swatch color={programClosed.main} />
          <Typography variant="caption">{t('programClosed')}</Typography>
        </Stack>
      </Stack>
    </LayoutSection>
  )
}
